import { render, staticRenderFns } from "./CategoryBlockWithToggle.vue?vue&type=template&id=718f4d17&scoped=true"
import script from "./CategoryBlockWithToggle.vue?vue&type=script&lang=js"
export * from "./CategoryBlockWithToggle.vue?vue&type=script&lang=js"
import style0 from "./CategoryBlockWithToggle.vue?vue&type=style&index=0&id=718f4d17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718f4d17",
  null
  
)

export default component.exports